// // src/utils/api.js
// import axios from 'axios';
// import { API_BASE_URL } from './constants';
// import toast from 'react-hot-toast';

// const api = axios.create({
//   baseURL: API_BASE_URL,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Request interceptor
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Response interceptor
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       window.location.href = '/login';
//       toast.error('Session expired. Please login again.');
//     }
//     return Promise.reject(error);
//   }
// );

// // Auth API
// export const login = async (credentials) => {
//   const response = await api.post('/login', credentials);
//   return response.data.data;
// };

// export const register = async (userData) => {
//   const response = await api.post('/register', userData);
//   return response.data;
// };

// // ... other imports and setup code ...

// // Services API - FIXED
// export const getServices = async () => {
//   const response = await api.get('/services');
//   return response.data.data || []; // Keep this
// };

// // In src/utils/api.js
// export const getService = async (id) => {
//   try {
//     const response = await api.get(`/services/${id}`);
//     console.log('Service detail API response:', response.data);
    
//     // Handle different response structures
//     if (response.data?.data?.data) {
//       return response.data.data.data;
//     } else if (response.data?.data) {
//       return response.data.data;
//     } else {
//       return response.data;
//     }
//   } catch (error) {
//     console.error('Error fetching service:', error);
//     throw error;
//   }
// };

// export const createService = async (serviceData) => {
//   const response = await api.post('/admin/services', serviceData);
//   return response.data.data || response.data; // Handle both
// };

// export const updateService = async (id, serviceData) => {
//   const response = await api.put(`/admin/services/${id}`, serviceData);
//   return response.data.data || response.data; // Handle both
// };

// export const deleteService = async (id) => {
//   const response = await api.delete(`/admin/services/${id}`);
//   return response.data.data || response.data; // Handle both
// };

// // Projects API - FIXED
// export const getProjects = async () => {
//   const response = await api.get('/projects');
//   return response.data.data || []; // Add .data
// };

// export const createProject = async (projectData) => {
//   const response = await api.post('/admin/projects', projectData);
//   return response.data.data || response.data;
// };

// export const updateProject = async (id, projectData) => {
//   const response = await api.put(`/admin/projects/${id}`, projectData);
//   return response.data.data || response.data;
// };

// export const deleteProject = async (id) => {
//   const response = await api.delete(`/admin/projects/${id}`);
//   return response.data.data || response.data;
// };

// // Media API - FIXED
// export const getMedia = async () => {
//   const response = await api.get('/media');
//   return response.data.data || [];
// };

// export const uploadMedia = async (mediaData) => {
//   const response = await api.post('/admin/media', mediaData);
//   return response.data.data || response.data;
// };

// export const deleteMedia = async (id) => {
//   const response = await api.delete(`/admin/media/${id}`);
//   return response.data.data || response.data;
// };

// // Certifications API - FIXED
// export const getCertifications = async () => {
//   const response = await api.get('/certifications');
//   return response.data.data || [];
// };

// export const createCertification = async (certData) => {
//   const response = await api.post('/admin/certifications', certData);
//   return response.data.data || response.data;
// };

// export const updateCertification = async (id, certData) => {
//   const response = await api.put(`/admin/certifications/${id}`, certData);
//   return response.data.data || response.data;
// };

// export const deleteCertification = async (id) => {
//   const response = await api.delete(`/admin/certifications/${id}`);
//   return response.data.data || response.data;
// };

// export default api;





// src/utils/api.js
// import axios from 'axios';
// import { API_BASE_URL } from './constants';
// import toast from 'react-hot-toast';

// const api = axios.create({
//   baseURL: API_BASE_URL,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Request interceptor
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Response interceptor
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       window.location.href = '/login';
//       toast.error('Session expired. Please login again.');
//     }
//     return Promise.reject(error);
//   }
// );

// // ============================================
// // AUTH API
// // ============================================

// export const login = async (credentials) => {
//   const response = await api.post('/login', credentials);
//   return response.data.data;
// };

// export const register = async (userData) => {
//   const response = await api.post('/register', userData);
//   return response.data;
// };

// // ============================================
// // SERVICES API
// // ============================================

// export const getServices = async () => {
//   const response = await api.get('/services');
//   return response.data.data || [];
// };

// export const getService = async (id) => {
//   try {
//     const response = await api.get(`/services/${id}`);
//     console.log('Service detail API response:', response.data);
    
//     if (response.data?.data?.data) {
//       return response.data.data.data;
//     } else if (response.data?.data) {
//       return response.data.data;
//     } else {
//       return response.data;
//     }
//   } catch (error) {
//     console.error('Error fetching service:', error);
//     throw error;
//   }
// };

// export const createService = async (serviceData) => {
//   const response = await api.post('/admin/services', serviceData);
//   return response.data.data || response.data;
// };

// export const updateService = async (id, serviceData) => {
//   const response = await api.put(`/admin/services/${id}`, serviceData);
//   return response.data.data || response.data;
// };

// export const deleteService = async (id) => {
//   const response = await api.delete(`/admin/services/${id}`);
//   return response.data.data || response.data;
// };

// // ============================================
// // PROJECTS API
// // ============================================

// export const getProjects = async () => {
//   const response = await api.get('/projects');
//   return response.data.data || [];
// };

// export const getProject = async (id) => {
//   try {
//     const response = await api.get(`/projects/${id}`);
//     console.log('Single project response:', response.data);
    
//     // Handle different response structures
//     if (response.data?.data?.data) {
//       return response.data.data.data;
//     } else if (response.data?.data) {
//       return response.data.data;
//     } else {
//       return response.data;
//     }
//   } catch (error) {
//     console.error('Error fetching project:', error);
//     throw error;
//   }
// };

// export const createProject = async (projectData) => {
//   console.log('API - Sending project data:', projectData);
  
//   try {
//     const response = await api.post('/admin/projects', projectData);
//     console.log('API - Create project response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('API - Error creating project:', error);
//     console.error('API - Error response:', error.response?.data);
//     throw error;
//   }
// };

// export const updateProject = async (id, projectData) => {
//   console.log('API - Updating project with data:', projectData);
  
//   try {
//     const response = await api.put(`/admin/projects/${id}`, projectData);
//     console.log('API - Update project response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('API - Error updating project:', error);
//     console.error('API - Error response:', error.response?.data);
//     throw error;
//   }
// };

// export const deleteProject = async (id) => {
//   const response = await api.delete(`/admin/projects/${id}`);
//   return response.data.data || response.data;
// };

// // ============================================
// // MEDIA API
// // ============================================

// export const getMedia = async () => {
//   const response = await api.get('/media');
//   const data = response.data.data || response.data;
  
//   if (Array.isArray(data)) {
//     return data.map(item => ({
//       id: item.id,
//       title: item.title,
//       description: item.description,
//       file_url: item.url,
//       media_type: item.type,
//       is_active: true,
//       created_at: item.created_at,
//       updated_at: item.updated_at,
//       category: item.category,
//       is_featured: item.is_featured
//     }));
//   }
//   return [];
// };

// export const getSingleMedia = async (id) => {
//   try {
//     const response = await api.get(`/media/${id}`);
//     console.log('Single media response:', response.data);
    
//     // Handle different response structures
//     if (response.data?.data?.data) {
//       return response.data.data.data;
//     } else if (response.data?.data) {
//       const data = response.data.data;
//       return {
//         id: data.id,
//         title: data.title,
//         description: data.description,
//         file_url: data.url,
//         media_type: data.type,
//         is_active: true,
//         created_at: data.created_at,
//         updated_at: data.updated_at,
//         category: data.category,
//         is_featured: data.is_featured
//       };
//     } else if (response.data) {
//       // Direct response
//       const data = response.data;
//       return {
//         id: data.id,
//         title: data.title,
//         description: data.description,
//         file_url: data.url,
//         media_type: data.type,
//         is_active: true,
//         created_at: data.created_at,
//         updated_at: data.updated_at,
//         category: data.category,
//         is_featured: data.is_featured
//       };
//     }
//     return null;
//   } catch (error) {
//     console.error('Error fetching single media:', error);
    
//     // If endpoint doesn't exist, fall back to filtering from all media
//     console.log('Falling back to filtering from all media...');
//     try {
//       const allMedia = await getMedia();
//       if (Array.isArray(allMedia)) {
//         const foundMedia = allMedia.find(item => item.id === id);
//         if (foundMedia) {
//           return foundMedia;
//         }
//       }
//       return null;
//     } catch (fallbackError) {
//       console.error('Fallback also failed:', fallbackError);
//       throw error;
//     }
//   }
// };

// export const uploadMedia = async (mediaData) => {
//   const transformedData = {
//     title: mediaData.title,
//     description: mediaData.description,
//     url: mediaData.file_url,
//     type: mediaData.media_type,
//     category: '',
//     is_featured: false
//   };
  
//   console.log('Sending transformed media data:', transformedData);
//   const response = await api.post('/admin/media', transformedData);
//   return response.data.data || response.data;
// };

// export const updateMedia = async (id, mediaData) => {
//   const transformedData = {
//     title: mediaData.title,
//     description: mediaData.description,
//     url: mediaData.file_url,
//     type: mediaData.media_type,
//     category: '',
//     is_featured: false
//   };
  
//   console.log('Updating media with transformed data:', transformedData);
//   const response = await api.put(`/admin/media/${id}`, transformedData);
//   return response.data.data || response.data;
// };

// export const deleteMedia = async (id) => {
//   const response = await api.delete(`/admin/media/${id}`);
//   return response.data.data || response.data;
// };

// // ============================================
// // CERTIFICATIONS API
// // ============================================

// export const getCertifications = async () => {
//   try {
//     const response = await api.get('/certifications');
//     console.log('All certifications response:', response.data);
    
//     // Handle different response structures
//     if (Array.isArray(response.data?.data)) {
//       return response.data.data;
//     } else if (Array.isArray(response.data)) {
//       return response.data;
//     } else if (response.data?.data?.data) {
//       return response.data.data.data;
//     }
//     return [];
//   } catch (error) {
//     console.error('Error fetching certifications:', error);
//     throw error;
//   }
// };

// export const getActiveCertifications = async () => {
//   try {
//     const response = await api.get('/certifications/active');
//     console.log('Active certifications response:', response.data);
    
//     if (Array.isArray(response.data?.data)) {
//       return response.data.data;
//     } else if (Array.isArray(response.data)) {
//       return response.data;
//     } else if (response.data?.data?.data) {
//       return response.data.data.data;
//     }
//     return [];
//   } catch (error) {
//     console.error('Error fetching active certifications:', error);
//     throw error;
//   }
// };

// export const getFeaturedCertifications = async (limit = 8) => {
//   try {
//     const response = await api.get(`/certifications/featured?limit=${limit}`);
//     console.log('Featured certifications response:', response.data);
    
//     if (Array.isArray(response.data?.data)) {
//       return response.data.data;
//     } else if (Array.isArray(response.data)) {
//       return response.data;
//     } else if (response.data?.data?.data) {
//       return response.data.data.data;
//     }
//     return [];
//   } catch (error) {
//     console.error('Error fetching featured certifications:', error);
//     throw error;
//   }
// };

// export const getCertificationsGrouped = async () => {
//   try {
//     const response = await api.get('/certifications/grouped');
//     console.log('Grouped certifications response:', response.data);
    
//     if (response.data?.data) {
//       return response.data.data;
//     }
//     return {};
//   } catch (error) {
//     console.error('Error fetching grouped certifications:', error);
//     throw error;
//   }
// };

// export const getZambiaAuthorities = async () => {
//   try {
//     const response = await api.get('/certifications/zambia-authorities');
//     console.log('Zambia authorities response:', response.data);
    
//     if (Array.isArray(response.data?.data)) {
//       return response.data.data;
//     } else if (Array.isArray(response.data)) {
//       return response.data;
//     }
//     return [];
//   } catch (error) {
//     console.error('Error fetching Zambia authorities:', error);
//     throw error;
//   }
// };

// export const getCertificationById = async (id) => {
//   try {
//     const response = await api.get(`/certifications/${id}`);
//     console.log('Single certification response:', response.data);
    
//     if (response.data?.data?.data) {
//       return response.data.data.data;
//     } else if (response.data?.data) {
//       return response.data.data;
//     } else {
//       return response.data;
//     }
//   } catch (error) {
//     console.error('Error fetching certification:', error);
//     throw error;
//   }
// };

// export const createCertification = async (certData) => {
//   try {
//     // Transform dates to ISO format with time
//     const transformedData = {
//       name: certData.name,
//       issuing_authority: certData.issuing_authority,
//       certificate_number: certData.certificate_number,
//       authority_acronym: certData.authority_acronym || certData.issuing_authority,
//       certificate_type: certData.certificate_type || 'General',
//       issue_date: certData.issue_date ? `${certData.issue_date}T00:00:00Z` : null,
//       expiry_date: certData.expiry_date ? `${certData.expiry_date}T00:00:00Z` : null,
//       image_url: certData.image_url,
//       thumbnail_url: certData.thumbnail_url,
//       document_number: certData.document_number,
//       is_active: certData.is_active !== undefined ? certData.is_active : true,
//       display_order: certData.display_order || 0,
//       is_featured: certData.is_featured || false,
//     };
    
//     console.log('Sending certification data:', transformedData);
//     const response = await api.post('/admin/certifications', transformedData);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error creating certification:', error);
//     throw error;
//   }
// };

// export const createZambiaCertification = async (certData) => {
//   try {
//     const transformedData = {
//       name: certData.name,
//       authority: certData.authority,
//       certificate_number: certData.certificate_number,
//       document_number: certData.document_number,
//       issue_date: certData.issue_date ? `${certData.issue_date}T00:00:00Z` : null,
//       expiry_date: certData.expiry_date ? `${certData.expiry_date}T00:00:00Z` : null,
//       certificate_image: certData.certificate_image,
//     };
    
//     console.log('Sending Zambia certification data:', transformedData);
//     const response = await api.post('/admin/certifications/zambia', transformedData);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error creating Zambia certification:', error);
//     throw error;
//   }
// };

// export const updateCertification = async (id, certData) => {
//   try {
//     // Prepare updates object with only provided fields
//     const updates = {};
    
//     if (certData.name !== undefined) updates.name = certData.name;
//     if (certData.issuing_authority !== undefined) updates.issuing_authority = certData.issuing_authority;
//     if (certData.certificate_number !== undefined) updates.certificate_number = certData.certificate_number;
//     if (certData.authority_acronym !== undefined) updates.authority_acronym = certData.authority_acronym;
//     if (certData.certificate_type !== undefined) updates.certificate_type = certData.certificate_type;
//     if (certData.image_url !== undefined) updates.image_url = certData.image_url;
//     if (certData.thumbnail_url !== undefined) updates.thumbnail_url = certData.thumbnail_url;
//     if (certData.document_number !== undefined) updates.document_number = certData.document_number;
//     if (certData.is_active !== undefined) updates.is_active = certData.is_active;
//     if (certData.display_order !== undefined) updates.display_order = certData.display_order;
//     if (certData.is_featured !== undefined) updates.is_featured = certData.is_featured;
    
//     // Handle dates
//     if (certData.issue_date !== undefined) {
//       updates.issue_date = certData.issue_date ? `${certData.issue_date}T00:00:00Z` : null;
//     }
//     if (certData.expiry_date !== undefined) {
//       updates.expiry_date = certData.expiry_date ? `${certData.expiry_date}T00:00:00Z` : null;
//     }
    
//     console.log('Updating certification with data:', updates);
//     const response = await api.put(`/admin/certifications/${id}`, updates);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error updating certification:', error);
//     throw error;
//   }
// };

// export const deleteCertification = async (id) => {
//   try {
//     const response = await api.delete(`/admin/certifications/${id}`);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error deleting certification:', error);
//     throw error;
//   }
// };

// export const toggleCertificationActive = async (id) => {
//   try {
//     const response = await api.patch(`/admin/certifications/${id}/toggle-active`);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error toggling certification status:', error);
//     throw error;
//   }
// };

// export const getCertificationStats = async () => {
//   try {
//     const response = await api.get('/admin/certifications/stats');
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error fetching certification stats:', error);
//     throw error;
//   }
// };

// export const getExpiringCertifications = async (days = 30) => {
//   try {
//     const response = await api.get(`/admin/certifications/expiring?days=${days}`);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error fetching expiring certifications:', error);
//     throw error;
//   }
// };

// // ============================================
// // USER MANAGEMENT API
// // ============================================

// // Get all users (super admin only)
// export const getAllUsers = async (page = 1, limit = 10) => {
//   try {
//     const response = await api.get(`/super-admin/users?page=${page}&limit=${limit}`);
//     console.log('Get all users response:', response.data);
    
//     // Handle different response structures
//     if (response.data?.data) {
//       return response.data.data;
//     } else if (response.data?.users) {
//       return response.data.users;
//     } else if (Array.isArray(response.data)) {
//       return response.data;
//     }
//     return [];
//   } catch (error) {
//     console.error('Error fetching all users:', error);
    
//     // Fallback to regular users endpoint if super admin endpoint fails
//     if (error.response?.status === 404 || error.response?.status === 403) {
//       console.log('Super admin endpoint not available, falling back to admin endpoint...');
//       try {
//         const fallbackResponse = await api.get(`/admin/users?page=${page}&limit=${limit}`);
//         if (fallbackResponse.data?.data) {
//           return fallbackResponse.data.data;
//         } else if (Array.isArray(fallbackResponse.data)) {
//           return fallbackResponse.data;
//         }
//         return [];
//       } catch (fallbackError) {
//         console.error('Fallback also failed:', fallbackError);
//         throw error;
//       }
//     }
//     throw error;
//   }
// };

// // Get users (admin endpoint)
// export const getUsers = async (page = 1, limit = 10) => {
//   try {
//     const response = await api.get(`/admin/users?page=${page}&limit=${limit}`);
//     console.log('Get users (admin) response:', response.data);
    
//     if (response.data?.data) {
//       return response.data.data;
//     } else if (Array.isArray(response.data)) {
//       return response.data;
//     }
//     return [];
//   } catch (error) {
//     console.error('Error fetching users:', error);
//     throw error;
//   }
// };

// // Toggle user active status
// export const toggleUserStatus = async (id) => {
//   try {
//     const response = await api.patch(`/super-admin/users/${id}/toggle-status`);
//     console.log('Toggle user status response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error toggling user status:', error);
    
//     // Fallback to update user endpoint
//     if (error.response?.status === 404) {
//       console.log('Toggle endpoint not available, using update endpoint...');
//       try {
//         // Get current user status from admin endpoint
//         const userResponse = await api.get(`/admin/users/${id}`);
//         const currentUser = userResponse.data.data || userResponse.data;
//         const newStatus = !currentUser.is_active;
        
//         // Update user status
//         const updateResponse = await api.put(`/admin/users/${id}`, {
//           is_active: newStatus
//         });
//         return updateResponse.data.data || updateResponse.data;
//       } catch (fallbackError) {
//         console.error('Fallback also failed:', fallbackError);
//         throw error;
//       }
//     }
//     throw error;
//   }
// };

// // Change user role (super admin only)
// export const changeUserRole = async (id, role) => {
//   try {
//     const response = await api.patch(`/super-admin/users/${id}/role`, { role });
//     console.log('Change user role response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error changing user role:', error);
    
//     // Fallback to update user endpoint
//     if (error.response?.status === 404) {
//       console.log('Change role endpoint not available, using update endpoint...');
//       try {
//         const response = await api.put(`/admin/users/${id}`, { role });
//         return response.data.data || response.data;
//       } catch (fallbackError) {
//         console.error('Fallback also failed:', fallbackError);
//         throw error;
//       }
//     }
//     throw error;
//   }
// };

// // Update user
// export const updateUser = async (id, userData) => {
//   try {
//     // Try super admin endpoint first
//     const response = await api.put(`/super-admin/users/${id}`, userData);
//     console.log('Update user response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error updating user (super admin):', error);
    
//     // Fallback to admin endpoint
//     if (error.response?.status === 404) {
//       console.log('Super admin update endpoint not available, trying admin endpoint...');
//       try {
//         const response = await api.put(`/admin/users/${id}`, userData);
//         return response.data.data || response.data;
//       } catch (fallbackError) {
//         console.error('Fallback also failed:', fallbackError);
//         throw error;
//       }
//     }
//     throw error;
//   }
// };

// // Delete user
// export const deleteUser = async (id) => {
//   try {
//     // Try super admin endpoint first
//     const response = await api.delete(`/super-admin/users/${id}`);
//     console.log('Delete user response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error deleting user (super admin):', error);
    
//     // Fallback to admin endpoint
//     if (error.response?.status === 404) {
//       console.log('Super admin delete endpoint not available, trying admin endpoint...');
//       try {
//         const response = await api.delete(`/admin/users/${id}`);
//         return response.data.data || response.data;
//       } catch (fallbackError) {
//         console.error('Fallback also failed:', fallbackError);
//         throw error;
//       }
//     }
//     throw error;
//   }
// };

// // ============================================
// // ADMIN MANAGEMENT API
// // ============================================

// // Get my permissions
// export const getMyPermissions = async () => {
//   try {
//     const response = await api.get('/admin/my-permissions');
//     console.log('Get my permissions response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error fetching permissions:', error);
//     throw error;
//   }
// };

// // Create admin (super admin only)
// export const createAdmin = async (adminData) => {
//   try {
//     const response = await api.post('/super-admin/admins', adminData);
//     console.log('Create admin response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error creating admin:', error);
//     throw error;
//   }
// };

// // Get all admins (super admin only)
// export const getAdmins = async (page = 1, limit = 10) => {
//   try {
//     const response = await api.get(`/super-admin/admins?page=${page}&limit=${limit}`);
//     console.log('Get admins response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error fetching admins:', error);
//     throw error;
//   }
// };

// // Get admin by ID (super admin only)
// export const getAdminById = async (id) => {
//   try {
//     const response = await api.get(`/super-admin/admins/${id}`);
//     console.log('Get admin by ID response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error fetching admin by ID:', error);
//     throw error;
//   }
// };

// // Update admin (super admin only)
// export const updateAdmin = async (id, adminData) => {
//   try {
//     const response = await api.put(`/super-admin/admins/${id}`, adminData);
//     console.log('Update admin response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error updating admin:', error);
//     throw error;
//   }
// };

// // Delete admin (super admin only)
// export const deleteAdmin = async (id) => {
//   try {
//     const response = await api.delete(`/super-admin/admins/${id}`);
//     console.log('Delete admin response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error deleting admin:', error);
//     throw error;
//   }
// };






// // Toggle admin status (super admin only)
// export const toggleAdminStatus = async (id) => {
//   try {
//     const response = await api.patch(`/super-admin/admins/${id}/toggle-status`);
//     console.log('Toggle admin status response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error toggling admin status:', error);
//     throw error;
//   }
// };

// // Get available permissions (super admin only)
// export const getAvailablePermissions = async () => {
//   try {
//     const response = await api.get('/super-admin/permissions');
//     console.log('Get available permissions response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error fetching available permissions:', error);
//     throw error;
//   }
// };




// // ============================================
// // AI ADMIN MANAGEMENT API
// // ============================================

// export const getAISettings = async () => {
//   try {
//     const response = await api.get('/admin/ai/instructions');
//     console.log('Get AI settings response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error fetching AI settings:', error);
//     throw error;
//   }
// };

// export const updateAISettings = async (instructions) => {
//   try {
//     const response = await api.put('/admin/ai/instructions', { instructions });
//     console.log('Update AI settings response:', response.data);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error updating AI settings:', error);
//     throw error;
//   }
// };



// // ============================================
// // CONTACT & MISC API
// // ============================================

// export const submitContactForm = async (contactData) => {
//   try {
//     const response = await api.post('/contact', contactData);
//     return response.data;
//   } catch (error) {
//     console.error('Error submitting contact form:', error);
    
//     // Provide more specific error messages
//     if (error.response) {
//       const errorData = error.response.data;
//       const errorMessage = errorData.error || errorData.message || 'Failed to send message';
      
//       const enhancedError = new Error(errorMessage);
//       enhancedError.response = error.response;
//       throw enhancedError;
//     } else if (error.request) {
//       throw new Error('Network error. Please check your internet connection and try again.');
//     } else {
//       throw new Error('Failed to send message. Please try again.');
//     }
//   }
// };

// export const getContactMessages = async () => {
//   try {
//     const response = await api.get('/admin/contact-messages');
//     return response.data.data || [];
//   } catch (error) {
//     console.error('Error fetching contact messages:', error);
//     throw error;
//   }
// };

// export const updateContactMessage = async (id, messageData) => {
//   try {
//     const response = await api.put(`/admin/contact-messages/${id}`, messageData);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error updating contact message:', error);
//     throw error;
//   }
// };

// export const deleteContactMessage = async (id) => {
//   try {
//     const response = await api.delete(`/admin/contact-messages/${id}`);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error deleting contact message:', error);
//     throw error;
//   }
// };

// // ============================================
// // DASHBOARD & STATS API
// // ============================================

// export const getDashboardStats = async () => {
//   try {
//     const response = await api.get('/admin/dashboard/stats');
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error fetching dashboard stats:', error);
//     throw error;
//   }
// };

// // ============================================
// // FILE UPLOAD API
// // ============================================

// export const uploadFile = async (formData) => {
//   try {
//     // Create a temporary axios instance for file upload
//     const uploadApi = axios.create({
//       baseURL: API_BASE_URL,
//       headers: {
//         'Content-Type': 'multipart/form-data',
//         'Authorization': `Bearer ${localStorage.getItem('token')}`
//       }
//     });
    
//     const response = await uploadApi.post('/upload', formData);
//     return response.data.data || response.data;
//   } catch (error) {
//     console.error('Error uploading file:', error);
//     throw error;
//   }
// };

// // ============================================
// // HEALTH CHECK
// // ============================================

// export const testApiConnection = async () => {
//   try {
//     const response = await api.get('/health');
//     return response.data;
//   } catch (error) {
//     console.error('API connection test failed:', error);
//     throw error;
//   }
// };

// // Export api instance
// export default api;




import axios from 'axios';
import { API_BASE_URL } from './constants';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      toast.error('Session expired. Please login again.');
    }
    return Promise.reject(error);
  }
);

// ============================================
// AUTH API
// ============================================

export const login = async (credentials) => {
  const response = await api.post('/login', credentials);
  return response.data.data;
};

export const register = async (userData) => {
  const response = await api.post('/register', userData);
  return response.data;
};

// ============================================
// SERVICES API (UPDATED WITH ADDITIONAL IMAGES)
// ============================================

export const getServices = async (category = '', page = 1, limit = 10) => {
  try {
    const params = {
      page,
      limit,
      ...(category && { category })
    };
    const response = await api.get('/services', { params });
    console.log('Get services response:', response.data);
    
    // Handle different response structures
    if (response.data?.data?.data) {
      return response.data.data.data;
    } else if (Array.isArray(response.data?.data)) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
};

export const getActiveServices = async (category = '', page = 1, limit = 10) => {
  try {
    const params = {
      page,
      limit,
      ...(category && { category })
    };
    const response = await api.get('/services/active', { params });
    console.log('Get active services response:', response.data);
    
    // Handle different response structures
    if (response.data?.data?.data) {
      return response.data.data.data;
    } else if (Array.isArray(response.data?.data)) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching active services:', error);
    throw error;
  }
};

export const getAllServices = async () => {
  try {
    const response = await api.get('/admin/services/all');
    console.log('Get all services response:', response.data);
    
    // Handle different response structures
    if (response.data?.data?.data) {
      return response.data.data.data;
    } else if (Array.isArray(response.data?.data)) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching all services:', error);
    throw error;
  }
};

export const getService = async (id) => {
  try {
    const response = await api.get(`/services/${id}`);
    console.log('Service detail API response:', response.data);
    
    // Handle different response structures
    if (response.data?.data?.data) {
      return response.data.data.data;
    } else if (response.data?.data) {
      return response.data.data;
    } else {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching service:', error);
    throw error;
  }
};

export const createService = async (serviceData) => {
  try {
    // Ensure details structure is correct
    if (!serviceData.details) {
      serviceData.details = { services: [], additionalImages: [] };
    } else {
      if (!serviceData.details.services) serviceData.details.services = [];
      if (!serviceData.details.additionalImages) serviceData.details.additionalImages = [];
    }
    
    console.log('Creating service with data:', serviceData);
    const response = await api.post('/admin/services', serviceData);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error creating service:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export const updateService = async (id, serviceData) => {
  try {
    // Ensure details structure is correct
    if (serviceData.details) {
      if (!serviceData.details.services) serviceData.details.services = [];
      if (!serviceData.details.additionalImages) serviceData.details.additionalImages = [];
    }
    
    console.log('Updating service with data:', serviceData);
    const response = await api.put(`/admin/services/${id}`, serviceData);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error updating service:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export const updateServiceWithMap = async (id, serviceData) => {
  try {
    console.log('Updating service with map data:', serviceData);
    const response = await api.put(`/admin/services/${id}`, serviceData);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error updating service with map:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export const deleteService = async (id) => {
  try {
    const response = await api.delete(`/admin/services/${id}`);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error deleting service:', error);
    throw error;
  }
};

export const toggleServiceActive = async (id) => {
  try {
    const response = await api.patch(`/admin/services/${id}/toggle-active`);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error toggling service status:', error);
    throw error;
  }
};

export const getServiceCategories = async () => {
  try {
    const response = await api.get('/services/categories');
    console.log('Service categories response:', response.data);
    
    // Handle different response structures
    if (Array.isArray(response.data?.data)) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching service categories:', error);
    throw error;
  }
};

// ============================================
// SERVICE ADDITIONAL IMAGES API
// ============================================

export const addServiceImage = async (serviceId, imageData) => {
  try {
    console.log('Adding image to service:', serviceId, imageData);
    const response = await api.post(`/admin/services/${serviceId}/images`, imageData);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error adding image to service:', error);
    throw error;
  }
};

export const getServiceImages = async (serviceId) => {
  try {
    const response = await api.get(`/admin/services/${serviceId}/images`);
    console.log('Get service images response:', response.data);
    
    // Handle different response structures
    if (Array.isArray(response.data?.data)) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching service images:', error);
    throw error;
  }
};

export const updateServiceImage = async (serviceId, imageData) => {
  try {
    console.log('Updating service image:', serviceId, imageData);
    const response = await api.put(`/admin/services/${serviceId}/images`, imageData);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error updating service image:', error);
    throw error;
  }
};

export const removeServiceImage = async (serviceId, imageUrl) => {
  try {
    const response = await api.delete(`/admin/services/${serviceId}/images`, {
      params: { url: imageUrl }
    });
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error removing service image:', error);
    throw error;
  }
};

// ============================================
// PROJECTS API
// ============================================

export const getProjects = async () => {
  const response = await api.get('/projects');
  return response.data.data || [];
};

export const getProject = async (id) => {
  try {
    const response = await api.get(`/projects/${id}`);
    console.log('Single project response:', response.data);
    
    // Handle different response structures
    if (response.data?.data?.data) {
      return response.data.data.data;
    } else if (response.data?.data) {
      return response.data.data;
    } else {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching project:', error);
    throw error;
  }
};

export const createProject = async (projectData) => {
  console.log('API - Sending project data:', projectData);
  
  try {
    const response = await api.post('/admin/projects', projectData);
    console.log('API - Create project response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('API - Error creating project:', error);
    console.error('API - Error response:', error.response?.data);
    throw error;
  }
};

export const updateProject = async (id, projectData) => {
  console.log('API - Updating project with data:', projectData);
  
  try {
    const response = await api.put(`/admin/projects/${id}`, projectData);
    console.log('API - Update project response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('API - Error updating project:', error);
    console.error('API - Error response:', error.response?.data);
    throw error;
  }
};

export const deleteProject = async (id) => {
  const response = await api.delete(`/admin/projects/${id}`);
  return response.data.data || response.data;
};

// ============================================
// MEDIA API
// ============================================

export const getMedia = async () => {
  const response = await api.get('/media');
  const data = response.data.data || response.data;
  
  if (Array.isArray(data)) {
    return data.map(item => ({
      id: item.id,
      title: item.title,
      description: item.description,
      file_url: item.url,
      media_type: item.type,
      is_active: true,
      created_at: item.created_at,
      updated_at: item.updated_at,
      category: item.category,
      is_featured: item.is_featured
    }));
  }
  return [];
};

export const getSingleMedia = async (id) => {
  try {
    const response = await api.get(`/media/${id}`);
    console.log('Single media response:', response.data);
    
    // Handle different response structures
    if (response.data?.data?.data) {
      return response.data.data.data;
    } else if (response.data?.data) {
      const data = response.data.data;
      return {
        id: data.id,
        title: data.title,
        description: data.description,
        file_url: data.url,
        media_type: data.type,
        is_active: true,
        created_at: data.created_at,
        updated_at: data.updated_at,
        category: data.category,
        is_featured: data.is_featured
      };
    } else if (response.data) {
      // Direct response
      const data = response.data;
      return {
        id: data.id,
        title: data.title,
        description: data.description,
        file_url: data.url,
        media_type: data.type,
        is_active: true,
        created_at: data.created_at,
        updated_at: data.updated_at,
        category: data.category,
        is_featured: data.is_featured
      };
    }
    return null;
  } catch (error) {
    console.error('Error fetching single media:', error);
    
    // If endpoint doesn't exist, fall back to filtering from all media
    console.log('Falling back to filtering from all media...');
    try {
      const allMedia = await getMedia();
      if (Array.isArray(allMedia)) {
        const foundMedia = allMedia.find(item => item.id === id);
        if (foundMedia) {
          return foundMedia;
        }
      }
      return null;
    } catch (fallbackError) {
      console.error('Fallback also failed:', fallbackError);
      throw error;
    }
  }
};

export const uploadMedia = async (mediaData) => {
  const transformedData = {
    title: mediaData.title,
    description: mediaData.description,
    url: mediaData.file_url,
    type: mediaData.media_type,
    category: '',
    is_featured: false
  };
  
  console.log('Sending transformed media data:', transformedData);
  const response = await api.post('/admin/media', transformedData);
  return response.data.data || response.data;
};

export const updateMedia = async (id, mediaData) => {
  const transformedData = {
    title: mediaData.title,
    description: mediaData.description,
    url: mediaData.file_url,
    type: mediaData.media_type,
    category: '',
    is_featured: false
  };
  
  console.log('Updating media with transformed data:', transformedData);
  const response = await api.put(`/admin/media/${id}`, transformedData);
  return response.data.data || response.data;
};

export const deleteMedia = async (id) => {
  const response = await api.delete(`/admin/media/${id}`);
  return response.data.data || response.data;
};

// ============================================
// CERTIFICATIONS API
// ============================================

export const getCertifications = async () => {
  try {
    const response = await api.get('/certifications');
    console.log('All certifications response:', response.data);
    
    // Handle different response structures
    if (Array.isArray(response.data?.data)) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data?.data?.data) {
      return response.data.data.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching certifications:', error);
    throw error;
  }
};

export const getActiveCertifications = async () => {
  try {
    const response = await api.get('/certifications/active');
    console.log('Active certifications response:', response.data);
    
    if (Array.isArray(response.data?.data)) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data?.data?.data) {
      return response.data.data.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching active certifications:', error);
    throw error;
  }
};

export const getFeaturedCertifications = async (limit = 8) => {
  try {
    const response = await api.get(`/certifications/featured?limit=${limit}`);
    console.log('Featured certifications response:', response.data);
    
    if (Array.isArray(response.data?.data)) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data?.data?.data) {
      return response.data.data.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching featured certifications:', error);
    throw error;
  }
};

export const getCertificationsGrouped = async () => {
  try {
    const response = await api.get('/certifications/grouped');
    console.log('Grouped certifications response:', response.data);
    
    if (response.data?.data) {
      return response.data.data;
    }
    return {};
  } catch (error) {
    console.error('Error fetching grouped certifications:', error);
    throw error;
  }
};

export const getZambiaAuthorities = async () => {
  try {
    const response = await api.get('/certifications/zambia-authorities');
    console.log('Zambia authorities response:', response.data);
    
    if (Array.isArray(response.data?.data)) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching Zambia authorities:', error);
    throw error;
  }
};

export const getCertificationById = async (id) => {
  try {
    const response = await api.get(`/certifications/${id}`);
    console.log('Single certification response:', response.data);
    
    if (response.data?.data?.data) {
      return response.data.data.data;
    } else if (response.data?.data) {
      return response.data.data;
    } else {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching certification:', error);
    throw error;
  }
};

export const createCertification = async (certData) => {
  try {
    // Transform dates to ISO format with time
    const transformedData = {
      name: certData.name,
      issuing_authority: certData.issuing_authority,
      certificate_number: certData.certificate_number,
      authority_acronym: certData.authority_acronym || certData.issuing_authority,
      certificate_type: certData.certificate_type || 'General',
      issue_date: certData.issue_date ? `${certData.issue_date}T00:00:00Z` : null,
      expiry_date: certData.expiry_date ? `${certData.expiry_date}T00:00:00Z` : null,
      image_url: certData.image_url,
      thumbnail_url: certData.thumbnail_url,
      document_number: certData.document_number,
      is_active: certData.is_active !== undefined ? certData.is_active : true,
      display_order: certData.display_order || 0,
      is_featured: certData.is_featured || false,
    };
    
    console.log('Sending certification data:', transformedData);
    const response = await api.post('/admin/certifications', transformedData);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error creating certification:', error);
    throw error;
  }
};

export const createZambiaCertification = async (certData) => {
  try {
    const transformedData = {
      name: certData.name,
      authority: certData.authority,
      certificate_number: certData.certificate_number,
      document_number: certData.document_number,
      issue_date: certData.issue_date ? `${certData.issue_date}T00:00:00Z` : null,
      expiry_date: certData.expiry_date ? `${certData.expiry_date}T00:00:00Z` : null,
      certificate_image: certData.certificate_image,
    };
    
    console.log('Sending Zambia certification data:', transformedData);
    const response = await api.post('/admin/certifications/zambia', transformedData);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error creating Zambia certification:', error);
    throw error;
  }
};

export const updateCertification = async (id, certData) => {
  try {
    // Prepare updates object with only provided fields
    const updates = {};
    
    if (certData.name !== undefined) updates.name = certData.name;
    if (certData.issuing_authority !== undefined) updates.issuing_authority = certData.issuing_authority;
    if (certData.certificate_number !== undefined) updates.certificate_number = certData.certificate_number;
    if (certData.authority_acronym !== undefined) updates.authority_acronym = certData.authority_acronym;
    if (certData.certificate_type !== undefined) updates.certificate_type = certData.certificate_type;
    if (certData.image_url !== undefined) updates.image_url = certData.image_url;
    if (certData.thumbnail_url !== undefined) updates.thumbnail_url = certData.thumbnail_url;
    if (certData.document_number !== undefined) updates.document_number = certData.document_number;
    if (certData.is_active !== undefined) updates.is_active = certData.is_active;
    if (certData.display_order !== undefined) updates.display_order = certData.display_order;
    if (certData.is_featured !== undefined) updates.is_featured = certData.is_featured;
    
    // Handle dates
    if (certData.issue_date !== undefined) {
      updates.issue_date = certData.issue_date ? `${certData.issue_date}T00:00:00Z` : null;
    }
    if (certData.expiry_date !== undefined) {
      updates.expiry_date = certData.expiry_date ? `${certData.expiry_date}T00:00:00Z` : null;
    }
    
    console.log('Updating certification with data:', updates);
    const response = await api.put(`/admin/certifications/${id}`, updates);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error updating certification:', error);
    throw error;
  }
};

export const deleteCertification = async (id) => {
  try {
    const response = await api.delete(`/admin/certifications/${id}`);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error deleting certification:', error);
    throw error;
  }
};

export const toggleCertificationActive = async (id) => {
  try {
    const response = await api.patch(`/admin/certifications/${id}/toggle-active`);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error toggling certification status:', error);
    throw error;
  }
};

export const getCertificationStats = async () => {
  try {
    const response = await api.get('/admin/certifications/stats');
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error fetching certification stats:', error);
    throw error;
  }
};

export const getExpiringCertifications = async (days = 30) => {
  try {
    const response = await api.get(`/admin/certifications/expiring?days=${days}`);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error fetching expiring certifications:', error);
    throw error;
  }
};

// ============================================
// USER MANAGEMENT API
// ============================================

// Get all users (super admin only)
export const getAllUsers = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`/super-admin/users?page=${page}&limit=${limit}`);
    console.log('Get all users response:', response.data);
    
    // Handle different response structures
    if (response.data?.data) {
      return response.data.data;
    } else if (response.data?.users) {
      return response.data.users;
    } else if (Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching all users:', error);
    
    // Fallback to regular users endpoint if super admin endpoint fails
    if (error.response?.status === 404 || error.response?.status === 403) {
      console.log('Super admin endpoint not available, falling back to admin endpoint...');
      try {
        const fallbackResponse = await api.get(`/admin/users?page=${page}&limit=${limit}`);
        if (fallbackResponse.data?.data) {
          return fallbackResponse.data.data;
        } else if (Array.isArray(fallbackResponse.data)) {
          return fallbackResponse.data;
        }
        return [];
      } catch (fallbackError) {
        console.error('Fallback also failed:', fallbackError);
        throw error;
      }
    }
    throw error;
  }
};

// Get users (admin endpoint)
export const getUsers = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`/admin/users?page=${page}&limit=${limit}`);
    console.log('Get users (admin) response:', response.data);
    
    if (response.data?.data) {
      return response.data.data;
    } else if (Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

// Toggle user active status
export const toggleUserStatus = async (id) => {
  try {
    const response = await api.patch(`/super-admin/users/${id}/toggle-status`);
    console.log('Toggle user status response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error toggling user status:', error);
    
    // Fallback to update user endpoint
    if (error.response?.status === 404) {
      console.log('Toggle endpoint not available, using update endpoint...');
      try {
        // Get current user status from admin endpoint
        const userResponse = await api.get(`/admin/users/${id}`);
        const currentUser = userResponse.data.data || userResponse.data;
        const newStatus = !currentUser.is_active;
        
        // Update user status
        const updateResponse = await api.put(`/admin/users/${id}`, {
          is_active: newStatus
        });
        return updateResponse.data.data || updateResponse.data;
      } catch (fallbackError) {
        console.error('Fallback also failed:', fallbackError);
        throw error;
      }
    }
    throw error;
  }
};

// Change user role (super admin only)
export const changeUserRole = async (id, role) => {
  try {
    const response = await api.patch(`/super-admin/users/${id}/role`, { role });
    console.log('Change user role response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error changing user role:', error);
    
    // Fallback to update user endpoint
    if (error.response?.status === 404) {
      console.log('Change role endpoint not available, using update endpoint...');
      try {
        const response = await api.put(`/admin/users/${id}`, { role });
        return response.data.data || response.data;
      } catch (fallbackError) {
        console.error('Fallback also failed:', fallbackError);
        throw error;
      }
    }
    throw error;
  }
};

// Update user
export const updateUser = async (id, userData) => {
  try {
    // Try super admin endpoint first
    const response = await api.put(`/super-admin/users/${id}`, userData);
    console.log('Update user response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error updating user (super admin):', error);
    
    // Fallback to admin endpoint
    if (error.response?.status === 404) {
      console.log('Super admin update endpoint not available, trying admin endpoint...');
      try {
        const response = await api.put(`/admin/users/${id}`, userData);
        return response.data.data || response.data;
      } catch (fallbackError) {
        console.error('Fallback also failed:', fallbackError);
        throw error;
      }
    }
    throw error;
  }
};

// Delete user
export const deleteUser = async (id) => {
  try {
    // Try super admin endpoint first
    const response = await api.delete(`/super-admin/users/${id}`);
    console.log('Delete user response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error deleting user (super admin):', error);
    
    // Fallback to admin endpoint
    if (error.response?.status === 404) {
      console.log('Super admin delete endpoint not available, trying admin endpoint...');
      try {
        const response = await api.delete(`/admin/users/${id}`);
        return response.data.data || response.data;
      } catch (fallbackError) {
        console.error('Fallback also failed:', fallbackError);
        throw error;
      }
    }
    throw error;
  }
};

// ============================================
// ADMIN MANAGEMENT API
// ============================================

// Get my permissions
export const getMyPermissions = async () => {
  try {
    const response = await api.get('/admin/my-permissions');
    console.log('Get my permissions response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error fetching permissions:', error);
    throw error;
  }
};

// Create admin (super admin only)
export const createAdmin = async (adminData) => {
  try {
    const response = await api.post('/super-admin/admins', adminData);
    console.log('Create admin response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error creating admin:', error);
    throw error;
  }
};

// Get all admins (super admin only)
export const getAdmins = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`/super-admin/admins?page=${page}&limit=${limit}`);
    console.log('Get admins response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error fetching admins:', error);
    throw error;
  }
};

// Get admin by ID (super admin only)
export const getAdminById = async (id) => {
  try {
    const response = await api.get(`/super-admin/admins/${id}`);
    console.log('Get admin by ID response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error fetching admin by ID:', error);
    throw error;
  }
};

// Update admin (super admin only)
export const updateAdmin = async (id, adminData) => {
  try {
    const response = await api.put(`/super-admin/admins/${id}`, adminData);
    console.log('Update admin response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error updating admin:', error);
    throw error;
  }
};

// Delete admin (super admin only)
export const deleteAdmin = async (id) => {
  try {
    const response = await api.delete(`/super-admin/admins/${id}`);
    console.log('Delete admin response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error deleting admin:', error);
    throw error;
  }
};

// Toggle admin status (super admin only)
export const toggleAdminStatus = async (id) => {
  try {
    const response = await api.patch(`/super-admin/admins/${id}/toggle-status`);
    console.log('Toggle admin status response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error toggling admin status:', error);
    throw error;
  }
};

// Get available permissions (super admin only)
export const getAvailablePermissions = async () => {
  try {
    const response = await api.get('/super-admin/permissions');
    console.log('Get available permissions response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error fetching available permissions:', error);
    throw error;
  }
};

// ============================================
// AI ADMIN MANAGEMENT API
// ============================================

export const getAISettings = async () => {
  try {
    const response = await api.get('/admin/ai/instructions');
    console.log('Get AI settings response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error fetching AI settings:', error);
    throw error;
  }
};

export const updateAISettings = async (instructions) => {
  try {
    const response = await api.put('/admin/ai/instructions', { instructions });
    console.log('Update AI settings response:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error updating AI settings:', error);
    throw error;
  }
};

// ============================================
// CONTACT & MISC API
// ============================================

export const submitContactForm = async (contactData) => {
  try {
    const response = await api.post('/contact', contactData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    
    // Provide more specific error messages
    if (error.response) {
      const errorData = error.response.data;
      const errorMessage = errorData.error || errorData.message || 'Failed to send message';
      
      const enhancedError = new Error(errorMessage);
      enhancedError.response = error.response;
      throw enhancedError;
    } else if (error.request) {
      throw new Error('Network error. Please check your internet connection and try again.');
    } else {
      throw new Error('Failed to send message. Please try again.');
    }
  }
};

export const getContactMessages = async () => {
  try {
    const response = await api.get('/admin/contact-messages');
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching contact messages:', error);
    throw error;
  }
};

export const updateContactMessage = async (id, messageData) => {
  try {
    const response = await api.put(`/admin/contact-messages/${id}`, messageData);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error updating contact message:', error);
    throw error;
  }
};

export const deleteContactMessage = async (id) => {
  try {
    const response = await api.delete(`/admin/contact-messages/${id}`);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error deleting contact message:', error);
    throw error;
  }
};

// ============================================
// DASHBOARD & STATS API
// ============================================

export const getDashboardStats = async () => {
  try {
    const response = await api.get('/admin/dashboard/stats');
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    throw error;
  }
};

// ============================================
// FILE UPLOAD API
// ============================================

export const uploadFile = async (formData) => {
  try {
    // Create a temporary axios instance for file upload
    const uploadApi = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    const response = await uploadApi.post('/upload', formData);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

// ============================================
// HEALTH CHECK
// ============================================

export const testApiConnection = async () => {
  try {
    const response = await api.get('/health');
    return response.data;
  } catch (error) {
    console.error('API connection test failed:', error);
    throw error;
  }
};

// ============================================
// UTILITY FUNCTIONS FOR SERVICE HANDLING
// ============================================

// Helper function to prepare service data for API
export const prepareServiceData = (formData, serviceItems, additionalImages) => {
  // Filter out empty service items
  const filteredServiceItems = serviceItems.filter(item => item.trim() !== '');
  
  // Filter out additional images without URL
  const validAdditionalImages = additionalImages.filter(img => img.url.trim() !== '');
  
  // Prepare the service data
  return {
    category: formData.category,
    title: formData.title,
    description: formData.description,
    image_url: formData.image_url,
    is_active: formData.is_active,
    details: {
      services: filteredServiceItems,
      additionalImages: validAdditionalImages.map(img => ({
        url: img.url,
        subtitle: img.subtitle || '',
        description: img.description || '',
        is_primary: img.is_primary || false
      }))
    }
  };
};

// Helper function to parse service details
export const parseServiceDetails = (service) => {
  let details = service.details;
  
  // Parse details if it's a string
  if (typeof details === 'string') {
    try {
      details = JSON.parse(details);
    } catch (e) {
      console.error('Error parsing service details:', e);
      details = { services: [], additionalImages: [] };
    }
  }
  
  // Initialize arrays if not present
  if (!details.services) details.services = [];
  if (!details.additionalImages) details.additionalImages = [];
  
  return details;
};

// Export api instance
export default api;